import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Product } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {

  constructor(private httpClient: HttpClient) { }

  toggleFavorite(productId: string): Observable<{ saved: boolean }> {
    const host = environment.host;
    return this.httpClient.post<{ saved: boolean }>(host + '/favorites/toggle', { productId });
  }

  getMyFavoriteIds(productIds: string[]): Observable<{ [productId: string]: boolean }> {
    const host = environment.host;
    return this.httpClient.post<{ [productId: string]: boolean }>(host + '/favorites/mine', { productIds });
  }

  getMyFavoriteProducts(): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/favorites');
  }
}
